import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http';
import { Country, CacheService, BusinessUnit } from 'mapfre-auditlib';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})

export class BusinessUnitService {

  className = 'BusinessUnitService'

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  getAllBusinessUnits(cache = true, cacheKey = "allBusinessUnits"): Observable<BusinessUnit[]>| any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<BusinessUnit[]>(environment.base_URL + "/units-business").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  getBusinessUnitsByEntity(entity, showDuplicated: Boolean = null, cache?, cacheKey = "businessUnitsByEntity"): Observable<BusinessUnit[]>| any {
    let params: any = { entityId: entity.join(',') };
    if (showDuplicated) {
      params.showDuplicated = showDuplicated;
    }
    if (this.cacheService.canUseCache(cacheKey, [entity.join('_'), showDuplicated ? 'duplicated' : 'uniq']) && cache) {
      return this.cacheService.getCacheData(cacheKey, [entity.join('_'), showDuplicated ? 'duplicated' : 'uniq']);
    } else {
      let observable = this.http.get<BusinessUnit[]>(environment.base_URL + "/units-business", { params }).pipe(map((res) => {
        this.cacheService.updateCacheData(res, cacheKey, [entity.join('_'), showDuplicated ? 'duplicated' : 'uniq'])
        return res;
      }))
      this.cacheService.updateCacheReq(cacheKey, [entity.join('_'), showDuplicated ? 'duplicated' : 'uniq']);
      return observable;
    }
  }

  newBusinessUnit(businessUnit) {
    return this.http.post(environment.base_URL + "/units-business", businessUnit)
  }

  updateBusinessUnit(businessUnit, id) {
    return this.http.put(environment.base_URL + `/units-business/${id}`, businessUnit)
  }

  /**
    * Delete Cache
    */

  deleteCache() {

    let memoryCache = ["businessUnitsByEntity"];

    _.forEach(memoryCache, item => {
      this.cacheService.deleteCache(item);
    })

  }
}

